type ValidatorWsUrlParams = {
  validatorServer?: string;
  validatorUrl?: string;
  explicitWsUrl?: string;
};

const isLocalValidatorServer = (validatorServer: string): boolean => {
  const normalized = validatorServer.toLowerCase();

  return (
    normalized.startsWith('localhost') ||
    normalized.startsWith('127.0.0.1') ||
    normalized.startsWith('[::1]') ||
    normalized.startsWith('host.docker.internal') ||
    normalized.endsWith(':8083')
  );
};

export function getValidatorWsUrl({ validatorServer, validatorUrl, explicitWsUrl }: ValidatorWsUrlParams): string | null {
  if (explicitWsUrl !== undefined) {
    return explicitWsUrl === '' ? null : explicitWsUrl;
  }

  // The overview passes the same network-specific base URL as its HTTP reads.
  // Keep hostname-only support for legacy callers and explicit local opt-in.
  const baseUrl = validatorUrl ?? (validatorServer ? `https://${validatorServer}` : undefined);
  if (!baseUrl) return null;

  let url: URL;
  try {
    url = new URL(baseUrl);
  } catch {
    return null;
  }

  if (isLocalValidatorServer(url.host) || (url.protocol !== 'http:' && url.protocol !== 'https:')) {
    return null;
  }

  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = `${url.pathname.replace(/\/+$/, '')}/ws`;
  url.search = '';
  url.hash = '';
  return url.toString();
}
